import { makeStyles, Tab } from '@material-ui/core';
import { Events } from '@type-r/models';
import { Linked, useEvent, useModel } from '@type-r/react';
import { getIdFromPath, PageContainer, PageTab, TransparentTabs, useLinkedLocation } from 'lqx-react';
import * as React from 'react';
import { useEffect } from 'react';
import { BankTransactionsSummary } from '../api';
import { PaymentDetails } from './payments';
import { TransactionPage } from './tiles/transaction';
import { ResolvePaymentsPage } from './unresolved';
import { Can } from 'src/app/services/can';
import { UserEntitlementCatalogs } from 'src/app/models/UserEntitlements';

export const BankTransactionsPage = () => {
  const $category = useLinkedLocation(3, 'all'),
    { value: category } = $category;

    return (Can(UserEntitlementCatalogs.BankEntryView) ||
      Can(UserEntitlementCatalogs.BankEntryWrite) ||
      Can(UserEntitlementCatalogs.BankEntryConfirm)) ? <>
      {category === 'details' ?
        <PaymentDetails paymentId={ getIdFromPath( 4 ) } />
    :
        <PageContainer
            header={
                <BankTransactionsPageTabs $category={ $category } />
            }
        >
            {
                category === 'all' ||
                category === 'ar' ||
                category === 'nonar' ||
                category === 'uac' ? <TransactionPage $category={$category} /> :
                category === 'unresolved' ? <ResolvePaymentsPage /> :
                <h1>Wrong path</h1>
            }

        </PageContainer>}</> : undefined
}

const BankTransactionsPageTabs = ({
  $category
}: {
  $category: Linked<string>;
}) => {
  const summary = useModel(BankTransactionsSummary),
    { allCount, arCount, nonArCount, uacCount, unresolvedCount } = summary;

  useEffect(() => {
    summary.fetch();
  }, [$category.value]);

  useEvent(Events, "bankTransactionSummary:refresh", () => {
    summary.fetch();
  });

  const classes = useStyles();

  return (
    <TransparentTabs $value={$category}>
      <PageTab value="all" title="All" label={String(allCount)} />

      <PageTab value="ar" title="AR" label={String(arCount)} />

      <PageTab value="nonar" title="Non-Ar" label={String(nonArCount)} />

      <PageTab value="uac" title="UAC" label={String(uacCount)} />
      <Tab
          aria-hidden="true"
          key="disabled"
          value={"separator"}
          disabled
          classes={{
            root: classes.separator
          }}
          label={<span className={classes.separatorElement} />}
        />
        <PageTab value="unresolved" title="Unresolved" label={String(unresolvedCount)} />
    </TransparentTabs>
  );
};

const useStyles = makeStyles({
  separator: {
    width: 35,
    minWidth: 20
  },

  separatorElement: {
    borderLeft: "solid",
    borderWidth: 1,
    borderColor: "white",
    height: 41,
    marginTop: 7
  }
});